import {
  PaymentBillingAddressInfo,
  PaymentInfo,
} from '../models/index';

const year = (new Date().getFullYear() - 2000 + 1).toString();

const paymentinfo: Record<string, PaymentInfo> = {
  validSVVisaPaymentDetails: {
    creditCardIndex: 3,
    cardNumber: '4012999999999999',
    cardHolderName: 'Test',
    expiryMonth: '12',
    expiryYear: '30',
    cvv: '123'
  },
  validUXMastercardPaymentDetails: {
    creditCardIndex: 2,
    cardNumber: '5555555555554444',
    cardHolderName: 'Test',
    expiryMonth: '03',
    expiryYear: '30',
    cvv: '737'
  },
  validUXVisaPaymentDetails: {
    creditCardIndex: 3,
    cardNumber: '4111111145551142',
    cardHolderName: 'Test',
    expiryMonth: '03',
    expiryYear: '30',
    cvv: '737'
  },
  validFrictionless3DSv2VisaCard: {
    creditCardIndex: 3,
    cardNumber: '4000000000001000',
    cardHolderName: 'Martin',
    expiryMonth: '01',
    expiryYear: year,
    cvv: '123'
  }
};

const paymentBillingAddressInfo: Record<string, PaymentBillingAddressInfo> = {
  validAddressDetails: {
    addressLine1: 'Test Address',
    postalCode: '560103',
    city: 'Nice',
    country: 'France'
  }
};

export const validSVVisaPaymentDetails = paymentinfo.validSVVisaPaymentDetails;
export const validUXVisaPaymentDetails = paymentinfo.validUXVisaPaymentDetails;
export const validUXMastercardPaymentDetails = paymentinfo.validUXMastercardPaymentDetails;
export const validAddressDetails = paymentBillingAddressInfo.validAddressDetails;
export const validFrictionless3DSv2VisaCard = paymentinfo.validFrictionless3DSv2VisaCard;
